import { render, staticRenderFns } from "./in-text.vue?vue&type=template&id=4e068c4c"
import script from "./in-text.vue?vue&type=script&lang=js"
export * from "./in-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports